import React from 'react';
import { Switch, Route } from 'react-router-dom';
import News from './News';
import Discover from './Discover';
import PageNotFound from './PageNotFound';
import DiscoverArticle from './DiscoverArticle';
import CityRumors from './CityRumors';
import SiteHeader from '../components/SiteHeader';
import Footer from '../components/Footer';
import { AboutUs } from './AboutUs';
import { Impressum } from './Impressum';
import {Dsgvo} from './Dsgvo';


export class AppRoot extends React.Component {
	render() {
		return (
			<div>
				<SiteHeader />
				
				<div className="site-content">
					<Switch>
						<Route exact path="/" component={News} />
						<Route exact path="/neues" component={News}/>
						<Route exact path="/entdecken" component={Discover} />
						<Route exact path="/entdecken/:articleName" component={DiscoverArticle} />
						<Route exact path="/stadtgefluester" component={CityRumors} />
						<Route exact path="/ueber-uns" component={AboutUs} />
						<Route exact path="/impressum" component={Impressum} />
						<Route exact path="/datenschutz" component={Dsgvo} />
						<Route component={PageNotFound} />
					</Switch>
				</div>

				<Footer />
			</div>
		);
	}
}

export default AppRoot;



// WEBPACK FOOTER //
// ./src/containers/AppRoot.js